"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowPasswordComponent = void 0;
const react_1 = __importStar(require("react"));
const crossed_eye_icon_1 = require("../icons/crossed-eye-icon");
const eye_icon_1 = require("../icons/eye-icon");
const input_styles_1 = require("../input.styles");
exports.ShowPasswordComponent = (0, react_1.memo)(({ showPassword, type, isError }) => (react_1.default.createElement(input_styles_1.StyledEyeIcon, { onClick: showPassword }, type === 'password' ? (react_1.default.createElement(eye_icon_1.EyeIcon, { isError: isError })) : (react_1.default.createElement(crossed_eye_icon_1.CrossedEyeIcon, { isError: isError })))));
